<div class="team-header">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxFlex>
      <button
        mat-button
        (click)="openEditTeamDialog()"
        [disabled]="teamIsArchived()"
        *ngIf="canEditTeam()"
        id="team-name-button"
      >
        <h1 *ngIf="team" [ngClass]="{ archived: teamIsArchived() }" id="team-name-header">
          {{ team.name }}
          <span *ngIf="teamIsArchived()">[archived]</span>
          <span class="date-range">
            {{ team.dateRange.toString('mediumDate', 'utc') }}
          </span>
        </h1>
      </button>
      <h1 *ngIf="team && !canEditTeam()" class="not-editable">
        {{ team.name }}
        <span *ngIf="teamIsArchived()">[archived]</span>
        <span class="date-range">
          {{ team.dateRange.toString('mediumDate', 'utc') }}
        </span>
      </h1>
    </div>
    <button
      *ngIf="team && team.hasCommunity()"
      class="action-buttons"
      mat-icon-button
      matTooltip="Team synced with a Higher Logic community"
      matTooltipShowDelay="500"
      aria-label="Team synced with a Higher Logic community"
    >
      <mat-icon>
        <img src="../assets/img/HigherLogicThumb.png" />
      </mat-icon>
    </button>
    <button
      class="action-buttons"
      mat-stroked-button
      [matMenuTriggerFor]="menu"
      matTooltip="More actions"
      aria-label="More actions"
      matTooltipShowDelay="500"
      id="more-actions-button"
    >
      Actions <mat-icon>arrow_drop_down</mat-icon>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="exportTeam()">
          <mat-icon>file_download</mat-icon>
          <span>Export Team</span>
        </button>
        <button *ngIf="team" mat-menu-item (click)="viewTeamRosterReport(team.name)">
          <mat-icon>summarize</mat-icon>
          <span>View Team in Roster Report</span>
        </button>
        <div *ngIf="canEditTeam()">
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="openEditTeamDialog()" [disabled]="teamIsArchived()" id="edit-team-button">
            <mat-icon>edit</mat-icon>
            <span>Edit Team</span>
          </button>
          <button mat-menu-item (click)="openPositionDialog()" [disabled]="teamIsArchived()">
            <mat-icon>add</mat-icon>
            <span>Add Position</span>
          </button>
          <mat-divider></mat-divider>
          <button
            mat-menu-item
            (click)="invitePicked()"
            [disabled]="team?.getPickedCount() == 0"
            id="invite-all-team-button"
          >
            <mat-icon>send</mat-icon>
            <span>Invite All to Team</span>
          </button>
          <button
            mat-menu-item
            (click)="remindInvited()"
            [disabled]="team?.getInvitedCount() == 0"
            id="remind-all-team-button"
          >
            <mat-icon>send</mat-icon>
            <span>Send reminder to invited</span>
          </button>
          <button mat-menu-item (click)="emailTeam()" [disabled]="!team?.hasPeopleOnSeats">
            <mat-icon>email</mat-icon>
            <span>Email Team</span>
            <mat-icon *ngIf="doesSendTeamEmailRequirePlanUpgrade()" class="locked">lock</mat-icon>
          </button>
          <button mat-menu-item (click)="openSendEvaluation()">
            <mat-icon>equalizer</mat-icon>
            <span>Send Evaluation</span>
          </button>
          <button mat-menu-item (click)="openSendSurvey()" *ngIf="isSurveyEnabled" [disabled]="!canSendSurvey()">
            <mat-icon>equalizer</mat-icon>
            <span>Send Team Survey</span>
          </button>
          <button mat-menu-item (click)="openSendTeamForm()">
            <mat-icon>equalizer</mat-icon>
            <span>Send Team Form</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="openCloneDialog()">
            <mat-icon>content_copy</mat-icon>
            <span>Clone Team</span>
          </button>
          <button mat-menu-item (click)="archiveTeam()" *ngIf="!teamIsArchived()">
            <mat-icon>archive</mat-icon>
            <span>Archive Team</span>
          </button>
          <button mat-menu-item (click)="unarchiveTeam()" *ngIf="teamIsArchived()">
            <mat-icon>unarchive</mat-icon>
            <span>Unarchive Team</span>
          </button>
          <button
            mat-menu-item
            class="team-delete"
            (click)="openDeleteTeamDialog()"
            *ngIf="canDeleteTeam()"
            id="delete-team-button"
          >
            <mat-icon>delete</mat-icon>
            <span>Delete Team</span>
          </button>
        </div>
      </mat-menu>
    </button>
    <button
      *ngIf="!hideDetailButton"
      class="outlined-button"
      mat-icon-button
      (click)="infoButtonClicked()"
      matTooltip="Show/hide team details"
      aria-label="Show or hide team details sidebar"
      matTooltipShowDelay="500"
    >
      <mat-icon>view_sidebar</mat-icon>
    </button>
  </div>
</div>
